
export default {
    name: 'app',
    data() {
        return {
        }
    },
    head() {
        return {
            title: '盼之代售官方APP下载-盼之代售-手游网游账号买号卖号平台',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: '盼之代售APP是专业游戏账号交易平台，为用户提供各种游戏账号交易服务，下载盼之代售APP方便用户实时查看账号交易相关。'
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: '盼之代售APP，盼之代售安卓APP，盼之代售软件'
                }
            ]
        }
    },
    methods: {
        download(){
            window.open('https://oss.pzds.com/pzdspcssr/20240613/Setup.exe');
        },
    },
}
